// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"361b4b09ddbb36d8","7265":"11d14a899827c0bf"}[chunkId] + ".css";
};